<app-browser-not-supported></app-browser-not-supported>
<app-split-pane></app-split-pane>
<app-download-tray></app-download-tray>
